import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import Thumbnail from "./Thumbnail";
import NoThumbnail from "./NoThumbnail";
import Slider from "react-slick";
import PropTypes from "prop-types";
import emptySneakerImg from "../../../../../images/emptysneakers2.png";
import emptyApparelImg from "../../../../../images/emptyapparels.png";
import emptyHandbagImg from "../../../../../images/emptyhandbags.png";
// import { getCacheImage } from "../../../../../config";
import { getCloudImageUrl, emptyImage } from "../../../../../utils";

/* ASSETS */
import SliderLeftHovered from '../../../../../images/left-black-arrow-3.png';
import SliderRightHovered from '../../../../../images/right-black-arrow-3.png';
import ArrowBlackLeft from '../../../../../images/arrow-black-left.png';
import ArrowBlackRight from '../../../../../images/arrow-black-right.png';

  const PrevSlide = ({ onClick, onMouseOver, onMouseOut, hoverLeft }) => {
    return (
      <div className="prev-button" onClick={onClick} onMouseOver={() => onMouseOver()} onMouseOut={() => onMouseOut()}>
        <KickImage src={hoverLeft ? ArrowBlackLeft : SliderLeftHovered} alt="..." />
      </div>
    )
  }

  const NextSlide = ({ onClick, onMouseOver, onMouseOut, hoverRight }) => {
    return (
      <div className="next-button" onClick={onClick} onMouseOver={() => onMouseOver()} onMouseOut={() => onMouseOut()}>
        <KickImage src={hoverRight ? ArrowBlackRight : SliderRightHovered} alt="..." />
      </div>
    )
  }

export default class Thumbnails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.active,
      hoverLeft: false,
      hoverRight: false,
    };
  }

  /* handling left arrow */
  handleHoverLeft = () => {
    this.setState({
      hoverLeft: !this.state.hoverLeft
    })
  }

  onClickLeft = () => {
    this.slider.slickPrev();
  }

  onMouseOverLeft = () => {
    this.setState({ hoverLeft: true })
  }

  onMouseOutLeft = () => {
    this.setState({ hoverLeft: false })
  }

  /* handling left arrow */
  handleHoverRight = () => {
    this.setState({
      hoverRight: !this.state.hoverRight
    })
  }

  onClickRight = () => {
    this.slider.slickNext();
  }

  onMouseOverRight = () => {
    this.setState({ hoverRight: true })
  }

  onMouseOutRight = () => {
    this.setState({ hoverRight: false })
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.active !== this.state.active &&
      nextProps.active !== this.props.active
    ) {
      this.setState({ active: nextProps.active }, () =>
        this.slider.slickGoTo(this.state.active)
      );
    }
  }

  render() {
    const settings = {
      autoplay: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: true,
      dots: true,
      swipe: true,
    };

    if (this.props.thumbnails.length === 0)
      return (
        <NoThumbnail src={emptyImage(this.props.selectedCategory)} alt="No Image.." />
      );
    return (
      <div className="slider-wrapper">
        <Slider
          ref={slider => (this.slider = slider)}
          dots={
            settings.dots
              ? this.props.thumbnails.length > this.props.lengthShow
                ? settings.dots
                : false
              : false
          }
          arrows={
            settings.arrows
              ? this.props.thumbnails.length > this.props.lengthShow
                ? settings.arrows
                : false
              : false
          }
          autoplay={
            settings.autoplay
              ? this.props.thumbnails.length > this.props.lengthShow
                ? settings.autoplay
                : false
              : false
          }
          afterChange={this.props.afterChange}
          beforeChange={this.props.beforeChange}
        >
          {this.props.renderItems
            ? this.props.renderItems(this.props.thumbnails)
            : this.props.thumbnails.map((item, index) => (
                <Thumbnail
                  src={getCloudImageUrl(item.URL, 1400, "product-image")}
                  key={index}
                  alt={`${item.signed_url}`}
                  category={this.props.category}
                />
              ))}
        </Slider>
        {
          this.props.thumbnails.length > this.props.lengthShow ? 
          <div>
            <PrevSlide 
              onClick={this.onClickLeft}
              onMouseOver={this.onMouseOverLeft} 
              onMouseOut={this.onMouseOutLeft} 
              hoverLeft={this.state.hoverLeft}
            />
            <NextSlide 
              onClick={this.onClickRight}
              onMouseOver={this.onMouseOverRight} 
              onMouseOut={this.onMouseOutRight} 
              hoverRight={this.state.hoverRight}
            />
          </div> : null
        }
      </div>
    );
  }
}
Thumbnails.propTypes = {
  thumbnails: PropTypes.array,
  caption: PropTypes.string
};
Thumbnails.defaultProps = {
  thumbnails: [],
  caption: "",
  lengthShow: 1,
  category: "sneakers"
};
